const Layout = () => import( /* webpackChunkName: 'index' */ '@/components/Layout')

const staticRoute = [{
		path: '/home',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'home' */ '@/views/home'),
		}]
	},
	{
		path: '/',
		redirect: '/home'
	},
	{
		path: '/area',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'area' */ '@/views/area'),
		}]
	},
	{
		path: '/circuit',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'circuit' */ '@/views/circuit'),
		}]
	},
	{
		path: '/concern',
		component: Layout,
		children: [{
			path: '',
			component: () => import( /* webpackChunkName: 'concern' */ '@/views/concern'),
		}]
	},
	// 模糊匹配
	{
		path: '*',
		redirect: '/home'
	}
]

export default staticRoute
